import { getDocFormatGraphInfo, getDocsUploadedGraphInfo } from "../store/documents/documentSlice";
import { getNewsTypeGraphInfo, getNewsUploadedGraphInfo } from "../store/news/newsSlice";
import {  months } from "./commonHelper";
import { other } from "./labelConstants";

export function prepareGraphData(obj) {
  
  return {
      labels: obj.data.map(x => x._id),
      datasets: obj.data.map(x => x.count),
      data:obj.data,
      total: obj.total
  };

}

export async function generateDocsGraphData(dispatch, template,period, config, isMounted){
    try{
      var action;
      var objParam;

      if(config.period){
        objParam={template:template, period:period, fieldName :config.dataPoint}
        action = getDocsUploadedGraphInfo;
      }else{
        objParam={template:template, filter:config.dataPoint}
        action = getDocFormatGraphInfo;
      }
  
      const res = await dispatch(action(objParam));
      const result = res?.payload?.data || {};
  
      if (Array.isArray(result.data) && isMounted) {
        return prepareGraphData(result);
      }
      return {};
    }
    catch(error){
      return {};
    }
}


export async function generateNewsGraphData(dispatch,period, config, isMounted){
  try{
    var action;
    var objParam;
    const dataPoint = config.dataPoint?.toLowerCase();

    if(dataPoint){
      objParam={}
      action = getNewsTypeGraphInfo;
    }else{
      objParam={period:period,fieldName :config.dataPoint}
      action = getNewsUploadedGraphInfo;
    }

    const res = await dispatch(action(objParam));
    const result = res?.payload?.data || {};

    if (Array.isArray(result.data) && isMounted) {
      return prepareGraphData(result);
    }
    return {};
  }
  catch(error){
    return {};
  }
}

export function getDateRangeForPeriod(label,period){
  switch (period) {
    case 'Yearly':
      var beginDate = new Date(label, 0, 1);   // January (0)
      var endDate = new Date(label+1, 0, 1);  // December (11)
      var filter = {
        'gte': beginDate,
        'lte': endDate
      };
      return filter;
      
    case 'Monthly':
      var [month,year] = label.split(' ');
      
      month = months.indexOf(month);
      year = parseInt('20' + year);
      
      beginDate = new Date(year, month, 1);   
      endDate = new Date(year, month+1, 1);
      filter = {
        'gte': beginDate,
        'lte': endDate
      };
      return filter

    case 'Quarterly':
      var [qtr,year] = label.split(' ');
      const quarters = {'Q1':0,'Q2':3,'Q3':6,'Q4':9};
      month=quarters[qtr];
      beginDate = new Date(year, month, 1);   
      endDate = new Date(year, month+3, 1);
      filter = {
          'gte': beginDate,
          'lte': endDate
        };
      
      return filter
  
    default:
      break;
  }
}


export function prepareDatasetForStackedBarChart(rawData,colors,fieldName,period) {
  var data;
  switch (period) {
    case 'Yearly':
      var currentYr = new Date().getFullYear();
      data = rawData.filter(item=>item._id <= currentYr);
      break;
    
    case 'Quarterly':
      var date = new Date();
      var currentQr = Math.ceil(date.getMonth()/3);
      var currentYr = date.getFullYear();
      data = rawData.filter(quarter => {
        if (/^Q\d \d{4}$/.test(quarter._id)){
          const [qtr, year] = quarter._id.split(' ');
          return parseInt(year) < currentYr || (parseInt(year) === currentYr && qtr <= `Q${currentQr}`);
        }      
      });
      break;

    default:
      data=rawData;
      break;
  }
  
  const datasets = {};
  const labels = [];
    const dataField = fieldName.includes('.')?fieldName.split('.')[1]:fieldName;
    // determining different field names
    data?.length>0 && data.forEach((item) => {
      if (item.groups) {
        item.groups.forEach((group) => {
          const fieldValue = (!group[dataField] || typeof group[dataField]==='object')?other:group[dataField];
          datasets[fieldValue] = datasets[fieldValue] || new Array(data.length).fill(0);
        });
      }
    });
  
    // determining values for each category
    data?.length>0 && data.forEach((item, index) => {
      labels[index]=item._id;
      if (item.groups) {
        item.groups.forEach((group) => {
          const fieldValue = (!group[dataField] || typeof group[dataField]==='object')?other:group[dataField];
          datasets[fieldValue][index] = group.count;
        });
      }else {
        Object.keys(datasets).forEach((fieldValue) => {
          datasets[fieldValue][index] = 0;
        });
      }
    });

  
    // creating array of objects
    const formattedDatasets = Object.keys(datasets).map((fieldValue,index) => {
      return {
        label: fieldValue,
        data: datasets[fieldValue],
        backgroundColor: colors[index % colors.length], // Replace with actual colors
        pointBackgroundColor:"#fff",
        pointRadius:4.3,
        pointHoverRadius:5,
        maxBarThickness: 50
      };
    });

    // sorting data so max category is at bottom of bar
    formattedDatasets.sort((a, b) => {
      const sumA = a.data.reduce((total, count) => total + count, 0);
      const sumB = b.data.reduce((total, count) => total + count, 0);
      return sumB - sumA;
    });

    const result = {
      labels,
      datasets:formattedDatasets
    }
    return result
  }

export function prepareDatasetForBarChart(rawLabels,rawDataset,graphConfig,period) {
    
  var labels;
  var dataset;
  switch (period) {
    case 'Yearly':
      const currentYear = new Date().getFullYear();
      labels = rawLabels.filter(item => item <= currentYear);
      var filteredIndices = rawLabels.map(year => labels.includes(year));
      dataset = rawDataset.filter((_, index) => filteredIndices[index]);
      break;

    case 'Quarterly':
      const date = new Date();
      const currentQr = Math.ceil(date.getMonth() / 3);
      const currentYr = date.getFullYear();
      labels = rawLabels.filter(quarter => {
          if (/^Q\d \d{4}$/.test(quarter)){
              const [qtr, year] = quarter.split(' ');
              return parseInt(year) < currentYr || (parseInt(year) === currentYr && qtr <= `Q${currentQr}`);
          }
      });
      var filteredIndices = rawLabels.map(quarter => labels.includes(quarter));
      dataset = rawDataset.filter((_, index) => filteredIndices[index]);
      break;

    default:
      labels = rawLabels.map((label) => (typeof label==='object')?other:label);
      dataset = rawDataset;
      break;
  }
  

  const formattedDatasets =  [{fill: true,
      label: graphConfig.label,
      data: dataset,
      borderColor: graphConfig.borderColor,
      backgroundColor: graphConfig.color,
      borderWidth:2,
      pointBackgroundColor:"#fff",
      pointRadius:4.3,
      pointHoverRadius:5,
      borderCapStyle: 'butt',
      borderDash: [],
      maxBarThickness: 50}]


  const result = {
    labels,
    datasets:formattedDatasets
  }
  return result
}  